// Generated from doskai-contracts/contracts/policies/growth-list-policy.ts. Do not edit.
/** Read-only domain policy shared by complete RTDB queries and loaded-row previews.
 * Delivery, authorization, entitlement and promo execution remain with existing owners. */
export type GrowthListDomain = 'subscriptions' | 'referrals' | 'promos';
/** Match the whitespace users see in rendered rows; preserve punctuation and Unicode. */
export function normalizeGrowthListSearchTerm(value: any) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/gu, ' ');
}
export function growthListStatusValues(domain: GrowthListDomain): string[] {
  const statuses: Record<GrowthListDomain, string[]> = {
    subscriptions: [
      'all',
      'inactive',
      'active',
      'cancelled',
      'past_due',
      'expired',
      'trialing',
      'incomplete',
      'incomplete_expired',
      'complimentary',
    ],
    referrals: ['all', 'attributed', 'rewarded', 'pending_reward'],
    promos: ['all', 'active', 'disabled', 'referral', 'eligible', 'expired', 'exhausted', 'scheduled'],
  };
  if (!Object.prototype.hasOwnProperty.call(statuses, domain)) throw new Error('Unknown record domain');
  return [...statuses[domain]];
}
export function growthListCriteria(domain: GrowthListDomain, input: any = {}) {
  const statuses = growthListStatusValues(domain);
  const search = normalizeGrowthListSearchTerm(input.search);
  const status = String(input.status || 'all')
    .trim()
    .toLowerCase();
  const sort = String(input.sort || 'newest');
  if (search.length > 200) throw new Error('Search is too long');
  if (!statuses.includes(status)) throw new Error('Unsupported status');
  if (!['newest', 'oldest', 'name'].includes(sort)) throw new Error('Unsupported sort');
  return { search, status, sort };
}
export function growthListMatches(domain: GrowthListDomain, row: any, input: any = {}) {
  const { search, status } = growthListCriteria(domain, input);
  const matchesStatus =
    status === 'all' ||
    row.status === status ||
    (status === 'complimentary' && !!row.isComplimentary) ||
    (status === 'referral' && !!row.isReferralPromo) ||
    (status === 'attributed' && !!row.referredBy) ||
    (status === 'rewarded' && row.rewardCount > 0) ||
    (status === 'pending_reward' && !!row.referredBy && row.rewardCount === 0) ||
    row.eligibility === status;
  const text = normalizeGrowthListSearchTerm(
    Object.values(row)
      .filter((value) => typeof value === 'string' || Array.isArray(value))
      .join(' ')
  );
  return matchesStatus && (!search || text.includes(search));
}
export function growthListOrderValue(row: any, input: any = {}): number | string {
  return input.sort === 'name'
    ? normalizeGrowthListSearchTerm(row.codeUpper || row.accountName || row.accountUserName || row.key)
    : Number(row.sortAt) || 0;
}
export function growthListCompare(a: any, b: any, input: any = {}) {
  const left = growthListOrderValue(a, input),
    right = growthListOrderValue(b, input);
  const order =
    left < right ? -1 : left > right ? 1 : String(a.key) < String(b.key) ? -1 : String(a.key) > String(b.key) ? 1 : 0;
  return input.sort === 'newest' || !input.sort ? -order : order;
}
